import axios from "axios";
import ConstantList from "../appConfig";
import HttpService from "./HttpService";

const API_PATH = ConstantList.API_EN_POINT_CRM + "/promotion-program";

export const pagingCurrentProgram = (searchObject) =>
  axios.post(API_PATH + "/paging-current-program", searchObject);

export const pagingProgram = (searchObject) =>
  axios.post(API_PATH + "/paging", searchObject);

export const pagingProgramCrmNotLoading = (searchObject) =>
  HttpService.getAxiosClient().post(API_PATH + `/paging`, searchObject);

export const pagingProgramGetId = (id) => axios.get(API_PATH + `/${id}/detail`);
export const findByPromotionCode = (searchObject) =>
  axios.post(API_PATH + "/find-by-promotion-code", searchObject);
